module.exports = __webpack_public_path__ + "img/vi.40c5255f.png";